import React, { useEffect, useState } from "react";
import { Layout, Menu, Badge, Button } from "antd";
import { useNavigate, Routes, Route } from "react-router-dom";
import axios from "axios";

import AppointmentList from "./Randevular/AppointmentList";
import AppointmentDetails from "./Randevular/AppointmentDetails";

import CreateBlogPage from "./Blog/CreateBlogPage";
import BlogPage from "./Blog/BlogPage";
import UpdateBlogPage from "./Blog/UpdateBlogPage";

import SubscriberListPage from "./Aboneler/SubscriberListPage";
import Statistics from "./Aboneler/Statistics";

import {
  DashboardOutlined,
  MailOutlined,
  CalendarOutlined,
  BarChartOutlined,
  ReadOutlined,
  RollbackOutlined,
  BellOutlined
} from "@ant-design/icons";

const { Sider, Header, Content } = Layout;

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [pendingCount, setPendingCount] = useState(0);
  const handleLogout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    localStorage.removeItem("email");
    localStorage.removeItem("avatar");
    navigate("/login");
  };
  // Bekleyen randevuları kontrol et
  const fetchPendingAppointments = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/appointments`);
      const pendingAppointments = response.data.filter(app => app.status === "pending");
      setPendingCount(pendingAppointments.length); // Bekleyen randevu sayısını güncelle
    } catch (error) {
      console.error("Bekleyen randevular alınamadı:", error);
    }
  };

  // İlk render'da ve durum güncellenince bekleyen randevuları kontrol et
  useEffect(() => {
    fetchPendingAppointments();

    // Her 30 saniyede bir yenileme işlemi yapalım
    const interval = setInterval(fetchPendingAppointments, 30000);
    return () => clearInterval(interval); // Temizleme
  }, []); // Sadece ilk renderda çalışacak

  // Durum güncellendikten sonra bekleyen sayısını anında güncelle
  const handleStatusUpdate = () => {
    fetchPendingAppointments(); // Durum değiştikten sonra tekrar bekleyen randevuları al
  };

  const menuItems = [
    {
      key: "1",
      icon: <DashboardOutlined />,
      label: "Kontrol Paneli",
      onClick: () => navigate(`/admin`)
    },
    {
      key: "2",
      icon: <ReadOutlined />,
      label: "Bloglar",
      children: [
        {
          key: "3",
          label: "Blog Listesi",
          onClick: () => navigate(`/admin/blogs`)
        },
        {
          key: "4",
          label: "Yeni Blog Oluştur",
          onClick: () => navigate(`/admin/blogs/create`)
        }
      ]
    },
    {
      key: "5",
      icon: <MailOutlined />,
      label: "Abone Listesi",
      onClick: () => navigate(`/admin/subscribe`)
    },
    {
      key: "6",
      icon: <BarChartOutlined />,
      label: "İstatistikler",
      onClick: () => navigate(`/admin/statistics`)
    },
    {
      key: "7",
      icon: <CalendarOutlined />,
      label: "Randevular",
      onClick: () => navigate(`/admin/appointments`)
    },
    {
      key: "8",
      icon: <RollbackOutlined />,
      label: "Siteye Git",
      onClick: () => navigate(`/`)
    }
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width={250} theme="dark">
        <Menu
          mode="inline"
          style={{ height: "100%", borderRight: 0 }}
          defaultSelectedKeys={["1"]}
          items={menuItems}
        />
      </Sider>
      <Layout>
      <Header style={{ background: "#001529", padding: "16px 24px" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <h1 style={{ margin: 0, color: "#fff" }}>Admin Paneli</h1>
    <Button onClick={handleLogout} type="default" danger>
      Çıkış Yap
    </Button>
  </div>

  {pendingCount > 0 && (
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
      <Badge count={pendingCount} offset={[10, 0]} size="default">
        <Button
          type="primary"
          icon={<BellOutlined />}
          onClick={() => navigate("/admin/appointments")}
        >
          Yeni Randevu Talebi
        </Button>
      </Badge>
    </div>
  )}
</Header>


        <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
          <div className="site-layout-background" style={{ padding: 24, minHeight: "80vh" }}>
            <Routes>
              <Route path="appointments" element={<AppointmentList onStatusUpdate={handleStatusUpdate} />} />
              <Route path="appointments/:id" element={<AppointmentDetails onStatusUpdate={handleStatusUpdate} />} />
              <Route path="blogs" element={<BlogPage />} />
              <Route path="blogs/create" element={<CreateBlogPage />} />
              <Route path="blogs/update/:id" element={<UpdateBlogPage />} />
              <Route path="subscribe" element={<SubscriberListPage />} />
              <Route path="statistics" element={<Statistics />} />
            </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminDashboard;
